module.exports = __webpack_public_path__ + "media/puzzle8_7.36dc6dc9.mp3";